// 供应商管理
import $ from '../base'

export default {

  // 供应商 - 列表
  supplierList: $.post('supplier/querySuppliers'),

  // 供应商 - 新增/编辑
  supplierCreateUpdate: $.post('supplier/addOrEditSupplier'),

  // 供应商 - 删除
  supplierDelete: $.post('supplier/delSupplier'),

  // 供应商类别 - 06 07
  supplierType: $.get('/supplier/supplierCodes'),

  // 供应商流水查询导出
  outQuerySupplierFlow: $.BASE_URL + '/order/outQuerySupplierFlow',

  // 供应商产品列表
  supplierCommodityList: $.post('/supplier/offer/pages'),

  // 供应商产品 - 新增
  supplierCommodityCreate: $.post('/supplier/offer/add'),

  // 供应商产品 - 编辑
  supplierCommodityUpdate: $.post('/supplier/offer/update'),

  // 供应商产品 - 删除
  supplierCommodityDelete: $.post('/supplier/offer/del'),

  // 供应商产品 - 状态
  supplierCommodityStatus: $.post('/supplier/offer/status')
}
